import { Box, type BoxProps } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/** Superficie para bloques de evidencia (EvidenceDrawer, citas expandidas)
 * — borde punteado sutil para leerse como "material de respaldo", distinto
 * de una superficie de contenido primario. */
export function EvidenceSurface({ sx, ...props }: BoxProps) {
  return (
    <Box
      sx={{
        borderRadius: 2,
        border: `1px dashed ${color.borderStrong}`,
        bgcolor: 'transparent',
        px: 2,
        py: 1.5,
        ...sx,
      }}
      {...props}
    />
  )
}
